import React from 'react';
import AiTracking from '../components/AiTracking';

// Features Page: Detailed features
const AiTrackingPage = () => {
  return (
    <>
      <AiTracking />
    </>
  );
};

export default AiTrackingPage;